import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from '../state/session-store.js';

const AUTO_HIDE_MS = 30_000;

/** Admin announcement shown across the top of the world; dismissible, hides itself after 30 s. */
export function AnnouncementBanner() {
  const { t } = useTranslation();
  const announcement = useSessionStore((s) => s.announcement);

  useEffect(() => {
    if (!announcement) return;
    const timer = window.setTimeout(
      () => useSessionStore.getState().setAnnouncement(undefined),
      AUTO_HIDE_MS,
    );
    return () => window.clearTimeout(timer);
  }, [announcement]);

  if (!announcement) return null;
  return (
    <div className="announcement" role="status">
      <strong>{t('announcement.label')}</strong> {announcement.text}
      <button
        type="button"
        className="secondary"
        onClick={() => useSessionStore.getState().setAnnouncement(undefined)}
        aria-label={t('common.dismiss')}
      >
        ×
      </button>
    </div>
  );
}
